import { AppDispatch, RootState } from '@src/store/store'
import { tariffsApi } from '@src/api/tariffs-api'
import { selectUserCurrentAddresses, selectUserServices } from '@src/store/ducks/user/selectors'
import {
  setAvailableTariffs, setBlockDescription, setBlockTariffs,
  setDopTariffs,
  setError,
  setFreeBlockDays,
  setIsLoading,
  setIsLoadingBlock,
  setIsLoadingChangeTariff,
  setIsSuccessBlock,
  setIsSuccessChangeTariff,
  setTariffInfo,
} from '@src/store/ducks/tariffs/reducer'
import { AvailableTariffGoodType } from '@src/store/ducks/tariffs/types'
import { Store } from 'react-notifications-component'
import { isString } from '@src/lib/utils'
import { errors } from '@src/messages/errors'
import { getAccounts } from '@src/store/ducks/user/thunks'
import { TariffType } from '@src/store/ducks/user/types'

export const getBlockDescription = () => async (dispatch: AppDispatch) => {
  try {
    const desc = await tariffsApi.getBlockDescription()

    dispatch(setBlockDescription(desc))
  } catch (err) {
    console.error(err)
  }
}

export const getBlockTariffs = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentAddresses) {
      const result = await tariffsApi.checkAvailableTariffs(
        AvailableTariffGoodType.BLOCKED,
        currentAddresses.accountId,
      )
      console.log('getBlockTariffs result ==== ', result)
      // @ts-ignore
      dispatch(setBlockTariffs(result))
    }
  } catch (err) {
    console.error(err)
  }
}
// export const getBlockTariffs = () => async (dispatch: AppDispatch, getState: () => RootState) => {
//   try {
//     const state = getState()
//     const services = selectUserServices(state)
//     const tariffs = services.tariff || []
//
//     if (tariffs.length === 0) {
//       return
//     }
//
//     const mergedTariffs = tariffs.map((userTariff) => ({
//       deviceId: userTariff.deviceId,
//       goodId: userTariff.goodId,
//       goodName: userTariff.goodName,
//       goodType: userTariff.goodType,
//       price: userTariff.price,
//       goodTypeId: userTariff.goodTypeId,
//       block: userTariff.block || null,
//     }))
//     console.log('mergedTariffs: ', mergedTariffs)
//
//     // @ts-ignore
//     dispatch(setBlockTariffs(mergedTariffs))
//   } catch (err) {
//     console.error('getBlockTariffs error:', err)
//   }
// }

export const getFreeBlockDays = (deviceId: number) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    const { tariff } = selectUserServices(getState())
    const currentTariff = tariff?.find((item) => item.deviceId === deviceId)

    if (currentTariff) {
      const result = await tariffsApi.getFreeBlockDays(currentTariff.accountId, currentTariff.deviceId)

      dispatch(setFreeBlockDays(result))
    }
  } catch (err) {
    console.error(err)
  }
}

export const blockTariff = (
  dateStart: string, dateEnd: string, deviceId: number,
) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoadingBlock(true))
    const { tariff } = selectUserServices(getState())
    const currentTariff: TariffType | any = tariff?.find((item) => item.deviceId === deviceId)
    const currentAddresses = selectUserCurrentAddresses(getState())

    if (currentTariff && currentAddresses) {
      const serviceId = currentTariff.block?.serviceId || currentTariff.serviceId
      const goodTypeId = currentTariff.block?.goodTypeId || currentTariff.goodTypeId

      await tariffsApi.blockTariff(
        currentAddresses.accountId,
        serviceId,
        currentTariff.deviceId,
        goodTypeId,
        dateStart,
        dateEnd,
      )

      dispatch(setIsSuccessBlock(true))
      dispatch(getAccounts())

      dispatch(getBlockTariffs())
    }
  } catch (err: any) {
    console.error('❌ Ошибка блокировки:', err?.response?.data || err)
    Store.addNotification({
      title: 'Ошибка!',
      message: err?.response?.data || 'Не удалось заблокировать услугу',
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: { duration: 5000 },
    })
  } finally {
    dispatch(setIsLoadingBlock(false))
  }
}

export const unblockTariff = (subscription: number) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoadingBlock(true))

    const state = getState()
    const services = selectUserServices(state)
    const tariff: TariffType | any = services.tariff?.find((t: any) => t.block?.serviceId === subscription)

    const serviceIdToUnblock = tariff?.serviceId || subscription

    await tariffsApi.unblockService(serviceIdToUnblock)

    dispatch(getAccounts())
    dispatch(getBlockTariffs())
  } catch (err: any) {
    console.error('❌ Ошибка разблокировки:', {
      message: err?.message,
      response: err?.response?.data,
      status: err?.response?.status,
      config: err?.config?.data,
    })

    const errorMessage = typeof err?.response?.data === 'string'
      ? err.response.data
      : err?.response?.data?.message || err?.message || 'Не удалось разблокировать услугу'

    Store.addNotification({
      title: 'Ошибка!',
      message: errorMessage,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: { duration: 5000 },
    })
  } finally {
    dispatch(setIsLoadingBlock(false))
  }
}

export const getDopTariffs = (serviceId: number) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoading(true))
    const { tariff } = selectUserServices(getState())
    const currentTariff = tariff?.find((item) => item.serviceId === serviceId)
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentTariff && currentAddresses) {
      const result = await tariffsApi.checkAvailableDopTariffs(
        currentTariff.accountId,
        currentTariff.dogovorId,
        currentTariff.deviceId,
        currentTariff.serviceId,
      )

      dispatch(setDopTariffs(result))
    }
  } catch (err) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}

export const getAvailableTariffs = (
  type: AvailableTariffGoodType,
  serviceId: number,
) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoading(true))
    const { tariff } = selectUserServices(getState())
    const currentTariff = tariff?.find((item) => item.serviceId === serviceId)
    if (currentTariff) {
      const result = await tariffsApi.checkAvailableTariffs(
        type, currentTariff.accountId, currentTariff.dogovorId, currentTariff.deviceId, currentTariff.goodId,
      )
      dispatch(setAvailableTariffs(result))
    }
  } catch (err) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}

export const addDopService = (
  newGoodId: number, serviceId: number,
) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoadingChangeTariff(true))
    const { tariff } = selectUserServices(getState())
    const currentTariff = tariff?.find((item) => item.serviceId === serviceId)
    if (currentTariff) {
      await tariffsApi.addDopService(
        currentTariff.accountId, currentTariff.dogovorId, currentTariff.deviceId, currentTariff.serviceId, newGoodId,
      )
      dispatch(setIsSuccessChangeTariff(true))
      dispatch(getDopTariffs(serviceId))
      dispatch(getAccounts())
    }
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } finally {
    dispatch(setIsLoadingChangeTariff(false))
  }
}

export const removeDopService = (serviceId: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setIsLoadingChangeTariff(true))
    await tariffsApi.delDopService(serviceId)
    dispatch(setIsSuccessChangeTariff(true))
    dispatch(getDopTariffs(serviceId))
    dispatch(getAccounts())
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } finally {
    dispatch(setIsLoadingChangeTariff(false))
  }
}

export const getTariffInfo = (goodId: number) => async (dispatch: AppDispatch) => {
  dispatch(setError(false))
  try {
    const result = await tariffsApi.getTariffInfo(goodId)
    dispatch(setTariffInfo(result))
  } catch (err) {
    // debugger
    console.error(err)
    dispatch(setError(true))
  }
}

export const selectTariff = (
  newGoodId: number, serviceId: number,
) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoadingChangeTariff(true))
    const { tariff } = selectUserServices(getState())
    const currentTariff = tariff?.find((item) => item.serviceId === serviceId)
    if (currentTariff) {
      await tariffsApi.changeTariff(
        currentTariff.accountId, currentTariff.dogovorId, currentTariff.deviceId, currentTariff.serviceId, newGoodId,
      )
      dispatch(getAccounts())
      dispatch(setIsSuccessChangeTariff(true))
    }
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } finally {
    dispatch(setIsLoadingChangeTariff(false))
  }
}
